<template>
  <span class="c-inline-label" :class="type">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "default"
    }
  }
};
</script>

<style scoped lang="scss">
.c-inline-label {
  display: inline-block;
  padding: 5px;
  border-radius: 4px;
  text-transform: none;
  font-size: 14px;
  font-weight: normal;
  font-family: $font-frutiger-light;
  letter-spacing: 1px;

  &.dark {
    background-color: #202020;
    color: $colour-nhs-core-white;
  }

  &.success {
    background-color: $colour-nhs-green;
    color: $colour-nhs-core-white;
  }

  &.danger {
    background-color: $colour-nhs-emergency-red;
    color: $colour-nhs-core-white;
  }

  &.warning {
    background-color: $colour-nhs-warm-yellow;
    color: $colour-nhs-core-white;
  }

  &.notice {
    background-color: $colour-nhs-dark-grey;
    color: $colour-nhs-core-white;

  }
}
</style>